import React from 'react'
import PropTypes from 'prop-types'
import { ReactSVG } from 'react-svg'
import { concatClasses } from '../../utils/fns'

const SvgIcon = (props) => {
  return (
    <ReactSVG
      className={concatClasses('svg-iconic-wrapper', props.className)}
      src={props.src}
      beforeInjection={(svg) => {
        svg.id = props.id
        svg.classList.add(...props.svgClasses.split(' '))
      }}
      title={props.alt}
    />
  )
}

SvgIcon.propTypes = {
  id: PropTypes.string,
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  svgClasses: PropTypes.string,
  alt: PropTypes.string,
}

SvgIcon.defaultProps = {
  id: '',
  className: '',
  svgClasses: 'iconic-sm',
  alt: 'SvgIcon',
}

export default SvgIcon
